import React, { FunctionComponent, useCallback, useState } from 'react';
import { Box, Button, DialogActions, DialogContent, useTheme } from '@material-ui/core';
import { ISpcTheme } from '../../../../../common/theme/ISpcTheme';
import useIsTablet from '../../../../../common/react/useIsTablet';
import usePlatformConfig from '../../../../../common/react/usePlatformConfig';
import MinimalLoader from '../../../../../common/components/presentation/MinimalLoader';
import InsuranceBlock from './InsuranceBlock';
import ModalWithHeader from '../../../../../common/components/presentation/ModalWithHeader';
import Translation from '../../../../../gqlCommon/components/translation/Translation';
import insuranceBlockContainerStyles from './insuranceBlockContainerStyles';
import SimpleButton from '../../../../../common/components/presentation/simpleButton/SimpleButton';
import useCustomizeCarContext from '../../../../hooks/useCustomizeCarContext';

export interface IInsuranceBlockFinanceContainerProps {
  displayBlock: boolean;
}

const InsuranceBlockFinanceContainer: FunctionComponent<IInsuranceBlockFinanceContainerProps> = ({ displayBlock }) => {
  const styles = insuranceBlockContainerStyles();
  const isTablet = useIsTablet();
  const [isLoading, setLoadingStatus] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const { selectedCar } = useCustomizeCarContext();
  const byoCode = selectedCar?.car.byoCode;

  const {
    platformConfig: { insuranceIntegration },
  } = usePlatformConfig();

  const {
    spc: {
      customise: { hideInsuranceQuoteCTA },
    },
  } = useTheme<ISpcTheme>();

  const toggleModal = useCallback(() => {
    setModalOpen(prev => !prev);
  }, []);

  if ((!byoCode && !insuranceIntegration) || !displayBlock || hideInsuranceQuoteCTA) {
    return null;
  }

  return (
    <Box pb={6} pt={!isTablet ? 6 : 0} data-test="insurance_block_finance_section" className={styles.financeContainer}>
      {isLoading && <MinimalLoader />}
      <Button
        variant="outlined"
        onClick={toggleModal}
        className={styles.financeButton}
        data-test="insurance_block_finance_section:view-cta"
      >
        <Translation id="trans__insurance__insurance_quote__cta2" />
      </Button>
      <ModalWithHeader
        open={modalOpen}
        toggleModal={toggleModal}
        title={<Translation id="trans__insurance__insurance_quote__title" />}
        disableEnforceFocus={true}
      >
        <DialogContent className={styles.root}>
          <InsuranceBlock
            config={{
              byoCode,
            }}
            setLoadingStatus={setLoadingStatus}
          />
        </DialogContent>
        <DialogActions className={styles.actionsContainer}>
          <SimpleButton
            type={'filled'}
            dataTest="insurance_block_finance_section:continue-cta"
            action={toggleModal}
            buttonClassName={styles.actionButton}
          >
            <Translation id="trans__insurance__insurance_quote__continue_cta" className={styles.actionButtonText} />
          </SimpleButton>
        </DialogActions>
      </ModalWithHeader>
    </Box>
  );
};

export default InsuranceBlockFinanceContainer;
